(function() {
  var bound = false;

  function toggleAccordion(btn) {
    var block = btn.closest('.block_footer');
    if (!block) return;
    var content = block.querySelector('.block-content.h_t');
    var isActive = btn.classList.contains('active');

    document.querySelectorAll('.custom-footer .f_btn_sl.active').forEach(function (otherBtn) {
      if (otherBtn === btn) return;
      otherBtn.classList.remove('active');
      var otherBlock = otherBtn.closest('.block_footer');
      var otherContent = otherBlock && otherBlock.querySelector('.block-content.h_t');
      if (otherContent) closeContent(otherContent);
    });

    if (isActive) {
      btn.classList.remove('active');
      closeContent(content);
    } else {
      btn.classList.add('active');
      openContent(content);
    }
  }

  function openContent(content) {
    if (!content) return;
    content.style.display = 'block';
    var height = content.scrollHeight;
    content.style.maxHeight = '0px';
    // reflow
    content.offsetHeight;
    content.style.maxHeight = height + 'px';
  }

  function closeContent(content) {
    if (!content) return;
    content.style.maxHeight = content.scrollHeight + 'px';
    content.offsetHeight;
    content.style.maxHeight = '0px';
  }

  function initFooter() {
    if (bound) return;
    bound = true;

    document.addEventListener('click', function (e) {
      if (window.innerWidth > 575) return;

      // আইকন বা title-block যেখানেই ক্লিক হোক, একই title-block ধরবে
      var titleBlock = e.target.closest('.custom-footer .block_footer .title-block');
      if (!titleBlock) return;

      e.preventDefault();
      e.stopPropagation();

      var btn = titleBlock.querySelector('.f_btn_sl');
      if (btn) toggleAccordion(btn);
    }, true); // capture phase ব্যবহার করে অন্য কোনো handler এর conflict এড়ানো হলো

    document.addEventListener('click', function (e) {
      var backTop = e.target.closest('#_desktop_back_top, .back_top');
      if (!backTop) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // transition শেষে display:none করে দেওয়া (বন্ধ অবস্থায়)
    document.querySelectorAll('.custom-footer .block_footer .block-content.h_t').forEach(function (content) {
      content.addEventListener('transitionend', function () {
        if (content.style.maxHeight === '0px') {
          content.style.display = 'none';
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    initFooter();
  } else {
    document.addEventListener('DOMContentLoaded', initFooter);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('shopify-section-footer') || e.target.querySelector('footer')) {
      initFooter();
    }
  });
})();